import React from 'react';
import PropTypes from 'prop-types';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import ScrollBarAdapter from 'components/pure/utils/ScrollBarAdapter';
import EnvActions from '@store/env/EnvActions';
import BrowserActions from 'actions/BrowserActions';
import 'components/init/globalStyles';
import ThirdPartyInit from 'components/init/ThirdPartyInit';
import {RouterLocation} from '@store/@types/util/ReactRouter';
import {getMuiV0Theme} from 'utils/css/themeUtils';

interface AppComponentProps {
  location: RouterLocation;
}

/**
 * Root component for our app.
 * Handles pre-login initialization
 *
 * See Router.tsx for component hierarchy
 * @link appRoutes
 *
 * See src/index.ts for app entry point
 */
export default class AppComponent extends React.Component<AppComponentProps> {
  // TODO remove once muiv0 is gone
  getChildContext() {
    return {
      muiTheme: getMuiTheme(getMuiV0Theme()),
    };
  }

  componentDidMount() {
    EnvActions.getEnv(); // get front-end environment variables
    BrowserActions.getTimezone(); // get user timezone
  }

  render() {
    return (
      <div style={{height: '100vh'}}>
        {/* TODO Determine if this is needed, remove if not */}
        <ScrollBarAdapter />
        <ThirdPartyInit location={this.props.location} />
        {this.props.children}
      </div>
    );
  }
}

// @ts-ignore
AppComponent.childContextTypes = {
  muiTheme: PropTypes.object,
};
